import { callGetApiToServer } from "../callApi";

export async function FetchCourse(Token) {
  try {
    let header = {
      Accept: "application/json",
      "Content-Type": "application/json",
      authorization: `Berear ${Token}`,
    };

    let endUrl = `v1/auth/admin/list-group-course`;

    let responseData = await callGetApiToServer(header, "GET", endUrl);

    return responseData;
  } catch (err) {
    throw err;
  }
}
